module.exports = global["jQuery"] = require("-!/biblio-ui-core/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
// module id = 2452
// module chunks = 0